import Auth from '../../../Amplify';
import {
  FIELD_NEXTTIME_LOGIN,
  menuSidebar,
  showErrorToast,
  showSuccessToast,
  STORAGE_TOKEN_COGNITO,
} from '../../shared/constants/Constants';
import { isOnlyReaderToDomain } from '../../../scripts/Util';
import Login from '../../shared/services/LoginService';

// CONSTANTES

const dataInicial = {};

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_ERROR = 'LOGIN_ERROR';
const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const setLoginUser = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

export default function loginReducer(state = dataInicial, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return { ...state, ...action.payload, errorLogin: null };
    case LOGIN_ERROR:
      return { ...state, errorLogin: action.payload };
    case LOGOUT_SUCCESS:
      return { ...dataInicial };
    default:
      return state;
  }
}

// ACCIONES

export const loginUser = (user, password) => async (dispatch) => {
  try {
    const response = await Login.responseAuth(user, password);
    const idToken = response.data ? response.data.token : null;
    const { idOrg } = response.data;
    localStorage.setItem(STORAGE_TOKEN_COGNITO, idToken);
    localStorage.setItem(FIELD_NEXTTIME_LOGIN, new Date());
    localStorage.setItem('idOrg', idOrg);
    const menuSidebarByOrg = menuSidebar[response.data.idOrg];

    dispatch({
      type: LOGIN_SUCCESS,
      payload: { ...response.data, fullName: response.data.user, menuSidebarByOrg },
    });
    showSuccessToast('Ingreso con éxito');
  } catch (error) {
    dispatch({
      type: LOGIN_ERROR,
      payload: 'Credenciales Incorrectas',
    });
    showErrorToast('Credenciales Incorrectas');
  }
};

export const logout = () => async (dispatch) => {
  try {
    dispatch({
      type: LOGOUT_SUCCESS,
    });
  } catch (error) {}
};
